import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './landing.module.css';

const slides = [
  {
    image: 'https://images.pexels.com/photos/1552242/pexels-photo-1552242.jpeg',
  },
  {
    image: 'https://images.pexels.com/photos/4498151/pexels-photo-4498151.jpeg',
  },
  {
    image: 'https://images.pexels.com/photos/3683074/pexels-photo-3683074.jpeg',
  }
];

const Landing = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const history = useHistory();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  const handleGetStarted = () => {
    history.push('/login');
  };

  return (
    <div className={styles.landingContainer}>
      <div className={styles.slideshow}>
        {slides.map((slide, index) => (
          <div 
            key={index} 
            className={`${styles.slide} ${index === currentSlide ? styles.active : ''}`}
          >
            <img 
              src={slide.image} 
              alt="Health Week" 
              className={styles.slideImage}
            />
          </div>
        ))}
        
        {/* Fast text och knapp */}
        <div className={styles.fixedContent}>
          <h2 className={styles.slideTitle}>Welcome to</h2>
          <h3 className={styles.slideSubtitle}>Health Week</h3>
          <p className={styles.slideDescription}>Start your journey to a healthier lifestyle today.</p>
          <button 
            className={styles.getStartedButton}
            onClick={handleGetStarted}
          >
            Get Started
          </button>
        </div>

        <div className={styles.slideIndicators}>
          {slides.map((_, index) => (
            <button
              key={index}
              className={`${styles.indicator} ${index === currentSlide ? styles.active : ''}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Landing;
